import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-[40px] shadow-2xl p-8 text-center border border-[#D4AF37]/20 relative overflow-hidden">
            {/* Background Decorations */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 rounded-bl-[100px] pointer-events-none"></div>
            
            <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mx-auto mb-6 border border-orange-100">
              <AlertTriangle className="w-10 h-10 text-orange-500" />
            </div>
            
            <h1 className="font-['Playfair_Display'] text-3xl font-bold text-[#1a1a1a] mb-4">
              Bir Şeyler Ters Gitti
            </h1>
            
            <p className="text-[#5A5A5A] mb-8 leading-relaxed">
              Üzgünüz, beklenmedik bir hata ile karşılaştık. Sayfayı yenilemeyi deneyebilir veya ana sayfaya dönebilirsiniz.
            </p>
            
            <div className="flex flex-col gap-3">
              <Button 
                onClick={() => window.location.reload()}
                className="w-full bg-[#D4AF37] hover:bg-[#B8941F] text-white rounded-full py-6 flex items-center justify-center gap-2 transition-all duration-300"
              >
                <RefreshCw className="w-5 h-5" />
                SAYFAYI YENİLE
              </Button>
              
              <Button 
                variant="outline"
                onClick={() => window.location.href = '/'}
                className="w-full border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-full py-6 flex items-center justify-center gap-2 transition-all duration-300"
              >
                <Home className="w-5 h-5" />
                ANA SAYFAYA DÖN
              </Button>
            </div>

            {process.env.NODE_ENV === 'development' && (
              <div className="mt-8 text-left p-4 bg-gray-50 rounded-xl overflow-auto max-h-40">
                <p className="text-xs font-mono text-red-600">
                  {this.state.error?.toString()}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
